import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css"; // Import your CSS file for styling

const NavBar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleItemClick = () => {
    setIsNavCollapsed(true);
  };

  return (
    <nav
      className="navbar navbar-expand-md navbar-light bg-light"
      style={{ padding: "0" }}
    >
      <div className="container-fluid">
        <button
          style={{ border: "none" }}
          className="navbar-toggler p-1" //giúp boostrap nhận diện nút bấm mở đóng/menu
          type="button"
          data-bs-toggle="collapse" //giúp boostrap biết đây là nút điều khiển collapse
          data-bs-target="#navbarNav" //liên kết với phần tử cần ẩn/hiện
          //aria-controls, aria-expanded, aria-label Không bắt buộc cho Bootstrap hoạt động, nhưng nên có để hỗ trợ truy cập (accessibility).
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          <span
            className="navbar-toggler-icon"
            style={{ width: "20px" }}
          ></span>
        </button>
        {/* thêm logo Rumi */}
        <div className="navbar-brand mx-auto text-center text-md-start">
          <img src="/images/logo1.png" alt="Rumi Logo" className="logo" />
        </div>

        <div
          className={`${isNavCollapsed ? "collapse collapse-horizontal" : ""} navbar-collapse`}
          id="navbarNav"
        >
          <ul
            className="navbar-nav d-flex gap-3 mx-auto"
            style={{ width: "fit-content" }}
          >
            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Trang chủ
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Sản phẩm
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Giới thiệu
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/news"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Tin tức
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/shop"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Cửa hàng
              </NavLink>
            </li>

            {/* <li className="nav-item">
              <NavLink
                to="/lucky-wheel"
                className={({ isActive }) =>
                  isActive ? "nav-link text-warning" : "nav-link custom-blue"
                }
                onClick={() => handleItemClick()}
              >
                Phần thưởng
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
